const TARGET = "qwik";
export {
  TARGET
};
